import { useEffect, useState } from "react";
import { omit } from "lodash";
import { AXES_REGEXP, CONFIDENCE_RANGE } from "../types";
const useResetRangeInitial = (plotLayout) => {
    const [graphDiv, setGraphDiv] = useState(null);
    useEffect(() => {
        if (graphDiv) {
            const layout = graphDiv._fullLayout;
            const axesKeys = Object.keys(layout).filter((key) => AXES_REGEXP.test(key));
            graphDiv._fullLayout = {
                ...layout,
                ...axesKeys.reduce((obj, key) => ({
                    ...obj,
                    [key]: {
                        ...(layout[key]._input.isConfidence
                            ? { ...layout[key], _rangeInitial: [...CONFIDENCE_RANGE] }
                            : omit(layout[key], "_rangeInitial")),
                    },
                }), {}),
            };
        }
    }, [graphDiv, plotLayout]);
    return { setGraphDiv };
};
export default useResetRangeInitial;
